import { Component } from 'opus-angular-seed-core';
import template from './template.html';
@Component({
    bindings: {
        list: '=',
        filter: '=',
        classifiers: '=',
        filterOverview: '=',
        defaultFilter: '=',
        sites: '=',
        chosenEmployees: '=',
        chosenManagers: '='
    },
    template
})
export default class {
    constructor ($translate, lodash, CLASSIFIER_ENUM, ROLE_CODE_ENUM, COURSE_STATUS_TYPE_ENUM, COURSE_TARGET_NEED_TYPE_ENUM,
                 MomentService, PrivilegeService, SiteService, StringService, TokenService, FilterService, USER_STATUS_ENUM, $window,
                 UserResource, moment, $element, DebounceService) {
        this.$translate = $translate;
        this.$element = $element;
        this.lodash = lodash;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.COURSE_STATUS_TYPE_ENUM = COURSE_STATUS_TYPE_ENUM;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
        this.MomentService = MomentService;
        this.TokenService = TokenService;
        this.PrivilegeService = PrivilegeService;
        this.SiteService = SiteService;
        this.StringService = StringService;
        this.FilterService = FilterService;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.$window = $window;
        this.UserResource = UserResource;
        this.moment = moment;
        this.DebounceService = DebounceService;
    }

    $onInit () {
        this.isOptionalCoursesEnabled = this.TokenService.isOptionalCoursesModuleEnabled();
        this.departments = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);

        this.filterOverview = {
            labels: {
                period: this.$translate.instant('filter.Period'),
                siteIds: this.$translate.instant('filter.Site'),
                departmentId: this.$translate.instant('filter.Course department'),
                roleId: this.$translate.instant('filter.Course role'),
                levelId: this.$translate.instant('filter.Course level'),
                course: this.$translate.instant('filter.Course name must contain'),
                uDepIds: this.$translate.instant('filter.Employee department'),
                uRoleIds: this.$translate.instant('filter.Employee role'),
                uLevelIds: this.$translate.instant('filter.Employee level'),
                employeeStatuses: this.$translate.instant('filter.Employee status')
            },
            values: {}
        };
        const fromLearnerProgress = this.$window.localStorage.getItem('courseresults:fromLearnerProgress') === '1';
        const hasSavedFilter = !!this.$window.localStorage.getItem('courseresults:filter');

        if (fromLearnerProgress && hasSavedFilter) {
            this.restoreFiltersFromSaved();
        }
        else {
            this.initFilters();
        }

        this.updateFilterOverview();
        this.filterTranslations = this.FilterService.getTranslations();

        this.filters = JSON.parse(this.$window.localStorage.getItem('is_course_results_report_filter_opened'));
        this.maximumTagsInInput = 3;

        this.debouncedQueryUsers = this.DebounceService.create(
            (query) => this.queryUsers(query),
            { minLength: 3, delay: 500 }
        );
        this.debouncedFilterManagers = this.DebounceService.create(
            (query) => this.filterManagers(query),
            { minLength: 3, delay: 500 }
        );
    }

    changeFilter () {
        this.filters = !this.filters;
        this.$window.localStorage.setItem('is_course_results_report_filter_opened', this.filters);
    }

    applyFilter () {
        const chosenManagers = this.chosenManagers || [];
        const chosenEmployees = this.chosenEmployees || [];
        if (chosenManagers.length > 3 || chosenEmployees.length > 3) {
            return;
        }
        this.filter.from = this.MomentService.format(this.filter.from, 'YYYY-MM-DD');
        this.filter.to = this.MomentService.format(this.filter.to, 'YYYY-MM-DD');

        this.filter.siteIds = this.siteFilter.model.map(site => site.value);

        this.filter.uDepIds = this.FilterService.departmentSelect.models
            .filter((department) => department.id !== null)
            .map((department) => department.id);

        this.filter.uRoleIds = this.FilterService.roleSelect.models
            .filter((role) => role.id !== null)
            .map(role => role.id);

        this.filter.uLevelIds = this.FilterService.levelSelect.models
            .filter((level) => level.id !== null)
            .map(level => level.id);

        if (this.isOptionalCoursesEnabled) {
            this.filter.participationTypes = this.participationFilter.model.map(participation => participation.value);
        }

        const employeeStatuses = !this.employeeStatusesFilter.model.length ? [] : this.employeeStatusesFilter.model.map(status => status.value);
        this.filter = this.lodash.assign(this.filter, { employeeStatuses });

        const trainingFieldIds = !this.trainingFieldFilter.model.length ? [] : this.trainingFieldFilter.model.map(field => field.value);
        this.filter = this.lodash.assign(this.filter, { trainingFieldIds });

        this.filter.employeeIds = this.chosenEmployees ? this.chosenEmployees.map(user => user.id) : [];
        this.filter.directManagerIds = this.chosenManagers ? this.chosenManagers.map(user => user.id) : [];

        this.saveFilterForLearnerProgress();

        this.list.fetch({}, this.filter).then(() => {
            this.updateFilterOverview();
        });
    }

    saveFilterForLearnerProgress () {
        this.$window.localStorage.setItem('courseresults:filter', JSON.stringify(this.filter));
        this.$window.localStorage.setItem('courseresults:chosenEmployees',
            JSON.stringify(this.chosenEmployees || []));
        this.$window.localStorage.setItem('courseresults:chosenManagers',
            JSON.stringify(this.chosenManagers || []));
    }

    queryUsers (query) {
        const params = {
            name: query,
            roleCode: this.ROLE_CODE_ENUM.KEYS.EMPLOYEE,
            pageSize: 0,
            privilegesCheck: 0
        };
        const siteIds = this.siteFilter.model.map(site => site.value);
        if (siteIds) {
            params['siteIds[]'] = siteIds;
        }
        return this.UserResource.query(params).$promise.then(data => {
            const items = data.items || data;
            return items.map(user => {
                user.customName = user.displayName;
                return user;
            });
        });
    }

    filterManagers (query) {
        const params = {
            name: query,
            roleCode: this.ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER,
            pageSize: 0,
            privilegesCheck: 0
        };
        const siteIds = this.siteFilter.model.map(site => site.value);
        if (siteIds) {
            params['siteIds[]'] = siteIds;
        }
        return this.UserResource.query(params).$promise.then(data => {
            const items = data.items || data;
            return items.map(user => {
                user.customName = user.displayName;
                return user;
            });
        });
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.siteFilter = angular.copy(this.defaultSiteFilter);
        this.chosenEmployees = [];
        this.chosenManagers = [];
        this.managerLimitError = null;
        this.employeeLimitError = null;
        this.clearTagsInputText();
        this.FilterService.initClassifierMultiFilter();

        if (this.isOptionalCoursesEnabled) {
            this.participationFilter = angular.copy(this.defaultParticipationFilter);
        }

        this.initEmployeeStatusesFilter();
        this.initTrainingFieldFilter();
        this.applyFilter();
    }

    clearTagsInputText () {
        const tagsInputElements = this.$element.find('tags-input input.input');
        if (tagsInputElements.length) {
            tagsInputElements.val('').trigger('input');
        }
    }

    onManagerTagAdding () {
        if (this.chosenManagers && this.chosenManagers.length >= this.maximumTagsInInput) {
            this.managerLimitError = this.$translate.instant('filter.Maximum X selections allowed',
                { maximum: this.maximumTagsInInput }
            );
            return false;
        }
        this.managerLimitError = null;
        return true;
    }

    onEmployeeTagAdding () {
        if (this.chosenEmployees && this.chosenEmployees.length >= 3) {
            this.employeeLimitError = this.$translate.instant('filter.Maximum X selections allowed',
                { maximum: this.maximumTagsInInput }
            );
            return false;
        }
        this.employeeLimitError = null;
        return true;
    }

    updateFilterOverview () {
        if (!this.list.invalid) {
            this.filterOverview.values = {};
            this.filterOverview.fullText = {};
            this.lodash.forEach(this.filter, (value, key) => {
                if (key === 'siteIds') {
                    const siteValues = value.map((siteId) => this.lodash.find(this.sites, { id: siteId }).name).join('; ');
                    this.filterOverview.values[key] = this.StringService.cutStringAndAppendEnding(siteValues);
                    this.filterOverview.fullText[key] = siteValues;
                }
                if (key === 'participationTypes') {
                    this.filterOverview.values[key] = value.map((participation) => this.COURSE_TARGET_NEED_TYPE_ENUM.LABELS[participation]).join('; ');
                }
                if (key === 'employeeStatuses') {
                    this.filterOverview.values[key] = value.map((status) => this.USER_STATUS_ENUM.LABELS[status]).join('; ');
                }
                if (key === 'uDepIds') {
                    this.filterOverview.values[key] = value.map((departmentId) => this.lodash.find(
                        this.FilterService.departments, { id: departmentId }).value
                    ).join('; ');
                }
                if (key === 'uRoleIds') {
                    this.filterOverview.values[key] = value.map((roleId) => this.lodash.find(
                        this.FilterService.roles, { id: roleId }).value
                    ).join('; ');
                }
                if (key === 'uLevelIds') {
                    this.filterOverview.values[key] = value.map((levelId) => this.lodash.find(
                        this.FilterService.levels, { id: levelId }).value
                    ).join('; ');
                }
                if (key === 'departmentId') {
                    this.filterOverview.values[key] = (this.lodash.find(this.departments, { id: value }) || {}).value;
                }
                else if (key === 'roleId') {
                    this.filterOverview.values[key] = (this.lodash.find(this.roles, { id: value }) || {}).value;
                }
                else if (key === 'levelId') {
                    this.filterOverview.values[key] = (this.lodash.find(this.levels, { id: value }) || {}).value;
                }
                else if (key === 'course' && value) {
                    this.filterOverview.values[key] = value;
                }
            });
            if (this.filter.to || this.filter.from) {
                const from = this.filter.from ? this.MomentService.formatDate(this.filter.from) : '...';
                const to = this.filter.to ? this.MomentService.formatDate(this.filter.to) : '...';
                this.filterOverview.values.period = `${from} - ${to}`;
            }
        }
    }

    restoreFiltersFromSaved () {
        this.$window.localStorage.removeItem('courseresults:fromLearnerProgress');
        this.$window.localStorage.removeItem('courseresults:filter');
        this.$window.localStorage.removeItem('courseresults:chosenEmployees');
        this.$window.localStorage.removeItem('courseresults:chosenManagers');


        this.FilterService.init(this.classifiers);

        this.defaultFilter.from = this.MomentService.format(this.moment().subtract(60, 'days'), 'YYYY-MM-DD');
        this.defaultFilter.to = this.MomentService.format(this.moment(), 'YYYY-MM-DD');

        const siteOptions = this.sites.map(site => ({ value: site.id, label: site.name }));
        const siteFilterSettings = {
            checkBoxes: true,
            showCheckAll: true,
            showUncheckAll: true,
            smartButtonMaxItems: 3,
            smartButtonTextConverter: (itemText) => itemText
        };
        const savedSiteIds = this.filter.siteIds || [];
        this.siteFilter = {
            model: savedSiteIds.length
                ? siteOptions.filter(opt => savedSiteIds.includes(opt.value))
                : [...siteOptions],
            options: siteOptions,
            settings: siteFilterSettings
        };
        this.defaultSiteFilter = { model: [...siteOptions], options: siteOptions, settings: siteFilterSettings };

        if (this.isOptionalCoursesEnabled) {
            const participationOptions = [
                { value: this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.COMPULSORY, label: this.COURSE_TARGET_NEED_TYPE_ENUM.LABELS.COMPULSORY },
                { value: this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.OPTIONAL, label: this.COURSE_TARGET_NEED_TYPE_ENUM.LABELS.OPTIONAL }
            ];
            const participationSettings = {
                checkBoxes: true,
                showCheckAll: true,
                showUncheckAll: true,
                smartButtonMaxItems: 3,
                smartButtonTextConverter: (itemText) => itemText
            };
            const savedParticipationTypes = this.filter.participationTypes || [];
            this.participationFilter = {
                model: savedParticipationTypes.length
                    ? participationOptions.filter(opt => savedParticipationTypes.includes(opt.value))
                    : [...participationOptions],
                options: participationOptions,
                settings: participationSettings
            };
            this.defaultParticipationFilter = { model: [...participationOptions], options: participationOptions, settings: participationSettings };
            this.filterOverview.labels.participationTypes = this.$translate.instant('filter.Participation');
        }

        this.initEmployeeStatusesFilter();
        const savedStatuses = this.filter.employeeStatuses || [];
        if (savedStatuses.length) {
            this.employeeStatusesFilter.model = this.employeeStatusesFilter.options
                .filter(opt => savedStatuses.includes(opt.value));
        }

        const trainingFieldOptions = this.classifiers
            .filter(classifier => classifier.type === this.CLASSIFIER_ENUM.KEYS.FIELD)
            .map(classifier => ({ value: classifier.id, label: classifier.value }));
        const savedTrainingFieldIds = this.filter.trainingFieldIds || [];
        this.trainingFieldFilter = {
            model: trainingFieldOptions.filter(opt => savedTrainingFieldIds.includes(opt.value)),
            options: trainingFieldOptions,
            settings: {
                checkBoxes: true,
                showCheckAll: true,
                showUncheckAll: true,
                enableSearch: true,
                smartButtonMaxItems: 3,
                smartButtonTextConverter: (itemText) => itemText
            }
        };

        const savedDepIds = this.filter.uDepIds || [];
        if (savedDepIds.length) {
            this.FilterService.departmentSelect.models = this.FilterService.departmentSelect.options
                .filter(opt => opt.id !== null && savedDepIds.includes(opt.id));
        }

        const savedRoleIds = this.filter.uRoleIds || [];
        if (savedRoleIds.length) {
            this.FilterService.roleSelect.models = this.FilterService.roleSelect.options
                .filter(opt => opt.id !== null && savedRoleIds.includes(opt.id));
        }

        const savedLevelIds = this.filter.uLevelIds || [];
        if (savedLevelIds.length) {
            this.FilterService.levelSelect.models = this.FilterService.levelSelect.options
                .filter(opt => opt.id !== null && savedLevelIds.includes(opt.id));
        }
    }

    initFilters () {
        this.FilterService.init(this.classifiers);

        this.defaultFilter.from = this.MomentService.format(this.moment().subtract(60, 'days'), 'YYYY-MM-DD');
        this.defaultFilter.to = this.MomentService.format(this.moment(), 'YYYY-MM-DD');
        this.filter.from = this.defaultFilter.from;
        this.filter.to = this.defaultFilter.to;

        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });
        const siteOptionsSelected = [...siteOptions];

        this.siteFilter = {
            model: siteOptionsSelected,
            options: siteOptions,
            settings: {
                checkBoxes: true,
                showCheckAll: true,
                showUncheckAll: true,
                smartButtonMaxItems: 3,
                smartButtonTextConverter: (itemText) => itemText
            }
        };

        if (this.isOptionalCoursesEnabled) {
            const participationOptions = [
                { value: this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.COMPULSORY, label: this.COURSE_TARGET_NEED_TYPE_ENUM.LABELS.COMPULSORY },
                { value: this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.OPTIONAL, label: this.COURSE_TARGET_NEED_TYPE_ENUM.LABELS.OPTIONAL }
            ];
            const participationOptionsSelected = [...participationOptions];

            this.participationFilter = {
                model: participationOptionsSelected,
                options: participationOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            };

            this.defaultParticipationFilter = angular.copy(this.participationFilter);
            this.filterOverview.labels.participationTypes = this.$translate.instant('filter.Participation');
        }

        this.initEmployeeStatusesFilter();
        this.initTrainingFieldFilter();

        this.defaultSiteFilter = angular.copy(this.siteFilter);
    }

    initTrainingFieldFilter () {
        const trainingFieldOptions = this.classifiers
            .filter(classifier => classifier.type === this.CLASSIFIER_ENUM.KEYS.FIELD)
            .map(classifier => {
                return {
                    value: classifier.id,
                    label: classifier.value
                };
            });

        this.trainingFieldFilter = {
            model: [],
            options: trainingFieldOptions,
            settings: {
                checkBoxes: true,
                showCheckAll: true,
                showUncheckAll: true,
                enableSearch: true,
                smartButtonMaxItems: 3,
                smartButtonTextConverter: (itemText) => itemText
            }
        };
    }

    initEmployeeStatusesFilter () {
        const employeeStatusOptions = [
            { value: this.USER_STATUS_ENUM.KEYS.ACTIVE, label: this.USER_STATUS_ENUM.LABELS.ACTIVE },
            { value: this.USER_STATUS_ENUM.KEYS.INACTIVE, label: this.USER_STATUS_ENUM.LABELS.INACTIVE },
            { value: this.USER_STATUS_ENUM.KEYS.NOT_STARTED, label: this.USER_STATUS_ENUM.LABELS.NOT_STARTED }
        ];

        const employeeStatusOptionsSelected = [employeeStatusOptions[0]];

        this.employeeStatusesFilter = {
            model: employeeStatusOptionsSelected,
            options: employeeStatusOptions,
            settings: {
                checkBoxes: true,
                showCheckAll: false,
                showUncheckAll: false,
                smartButtonMaxItems: 3,
                smartButtonTextConverter: (itemText) => itemText
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/courseresults/filter/index.js